import type { AnonymousUiUsageEventFields } from '@packages/types';
import type { FieldErrors, FieldValues } from 'react-hook-form';
import { track } from './ui-usage.tracker';

type InvalidFormEvent = AnonymousUiUsageEventFields<'ui-usage.anonymous.form.invalid'>;

/** One `form.invalid` payload per form: `field` is only valid for the `form` beside it. */
export type InvalidFormFields = InvalidFormEvent extends infer E
  ? E extends { form: infer Form; field: infer Field }
    ? { form: Form; field: Field }
    : never
  : never;

/** A form's fields in page order, each with the closed `form.invalid` payload recorded for it. */
export type InvalidFieldTable<V extends FieldValues> = readonly (readonly [formKey: keyof V, fields: InvalidFormFields])[];

/**
 * Records `form.invalid` for the first invalid field in page order, the one react-hook-form
 * focuses. Pass it as the `onInvalid` handler of `handleSubmit`.
 */
export function trackFirstInvalidField<V extends FieldValues>(table: InvalidFieldTable<V>, invalid: FieldErrors<V>): void {
  const first = table.find(([key]) => invalid[key] !== undefined);
  if (first) track('ui-usage.anonymous.form.invalid', first[1]);
}
